import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cn } from '../../../utils';
import {
  getBreakingNewsAsync,
  updateBreakingNewsClickAsync,
} from '../../store/slices/common/commonSlice';
import { getCityDetailsFromName } from '../../../utils/cityUtils';
const NewsTicker = () => {
  const router = useRouter();
  const { city } = router.query;

  const breakingNews = useSelector(({ common }) => common?.breakingNews);

  const dispatch = useDispatch();
  const cityId = getCityDetailsFromName(city)?.id || 1;
  const handleBreakingNewsClick = (item) => {
    if (item?.url) {
      dispatch(updateBreakingNewsClickAsync({ id: item?.id }));
      window.open(item?.url, '_blank');
    }
  };
  useEffect(() => {
    if (city) {
      dispatch(getBreakingNewsAsync({ city_id: cityId }));
    }
  }, [city]);

  return (
    <>
      {breakingNews && breakingNews?.id ? (
        <div
          style={{
            backgroundColor: breakingNews?.background_color || '#212121',
          }}
          className='fixed bottom-0 left-0 right-0 z-50 overflow-hidden  py-2 font-semibold text-white'
        >
          <div className='flex animate-marquee whitespace-nowrap'>
            {/* {breakingNews &&
              breakingNews?.length > 0 &&
              breakingNews.map((item, index) => (
                <>
                  <div
                    key={index}
                    onClick={() => handleBreakingNewsClick(item)}
                    className={cn(
                      item?.url ? 'cursor-pointer' : 'cursor-default'
                    )}
                    style={{ backgroundColor: item?.background_color }}
                    dangerouslySetInnerHTML={{ __html: item?.title }}
                  />
                  {index < breakingNews.length - 1 && (
                    <span className='mx-3'>•</span>
                  )}
                </>
              ))} */}

            <div
              onClick={() => handleBreakingNewsClick(breakingNews)}
              className={cn(
                breakingNews?.url ? 'cursor-pointer' : 'cursor-default'
              )}
              // style={{ backgroundColor: breakingNews?.background_color }}
              dangerouslySetInnerHTML={{ __html: breakingNews?.title }}
            />
          </div>
        </div>
      ) : null}
    </>
  );
};

export default NewsTicker;
